import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
import { includes } from 'lodash'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  GetStartedInput,
  DeforestationRiskSectorIconRow,
  ScreenedCompanies,
} from '../../components'
import Styles from './Companies.css'


@CSSModules(Styles, {allowMultiple: true})
export default class Companies extends Component {
  constructor(props){
    super(props)
    this.state = {
      url: config.domain + config.routes.companies,
      title: 'Deforestation-risk companies',
      // TODO: see if this list needs to be updated
      orderedCompanyIds: [
        'C_K3chBb5g',
        'C_a3Cv3nzJ',
        'C_00wDg0ni',
        'C_VyqwdTBx',
        'C_2GcExNq0',
        'C_EmQ1ibmM',
        'C_v5H8hxf1',
        'C_qo4LHjld',
        'C_kfW3YHIK',
        'C_nnSg5X5F',
        'C_AaR8LUBv',
        'C_TLaT43rI',
        'C_guU1xGgQ',
        // '0C00003APU', // Wilmar Cahaya - no funds own, no company record
        'C_TKN8pHyz',
        'C_DHXeFMXI',
        'C_0Sit4bcG',
        'C_baOMhMnB',
        'C_6XBl1KEM',
        'C_uyj6Hd4f',
        'C_4pg7ISWo',
        'C_0id7elVy'
      ]
    }
  }

  renderFlags = (flags) => {
    if (flags.length > 0) {
      //
      return <div styleName='flag-box'>
        {
          flags.map(flag => {
            const splitName = flag[2].split(' ')
            let shortname = splitName[0]
            shortname = shortname === 'Palm' ? 'Palm oil' : shortname
            const type = splitName[splitName.length - 1]
            const stylNmTyp = type === 'producer' ? 'flag-p' : 'flag-c'
            const stylNm = 'flag ' + stylNmTyp

            return <span styleName={stylNm} key={flag[0]}>
              <img
                styleName='detail-icon-holding'
                src={flag[1]}
                alt={flag[2]}
                title={flag[2]}
              />
              {shortname}
            </span>
          })
        }
      </div>
    }
    //
    return null
  }

  render() {
    // images
    const producersIcon = require('../../../static/images/icn-producers.svg')
    const consumersIcon = require('../../../static/images/icn-consumers.svg')
    const iconPo = require('../../../static/images/icn-po.svg')
    const iconPp = require('../../../static/images/icn-pp.svg')
    const iconRb = require('../../../static/images/icn-rb.svg')
    const iconTb = require('../../../static/images/icn-tb.svg')
    const iconBf = require('../../../static/images/icn-bf.svg')
    const iconSy = require('../../../static/images/icn-sy.svg')
    const iconPoY = require('../../../static/images/icn-po-y.svg')
    const iconPpY = require('../../../static/images/icn-pp-y.svg')
    const iconRbY = require('../../../static/images/icn-rb-y.svg')
    const iconTbY = require('../../../static/images/icn-tb-y.svg')
    const iconBfY = require('../../../static/images/icn-bf-y.svg')
    const iconSyY = require('../../../static/images/icn-sy-y.svg')

    //
    return <div>
      {container.helmet(this.state.title, '', this.state.url)}
      <ContainerDivs>

        <header>
          <h1 styleName='header__title'>{this.state.title}</h1>

          <p styleName='header__text'>
            Deforestation Free Funds tracks companies exposed to deforestation
            risk across six commodities: palm oil, paper/pulp, rubber, timber,
            cattle, and soy. The companies are grouped by business types:
            agricultural commodity
            producers and traders, banks and lenders, and major consumer
            brands.
          </p>

          <DeforestationRiskSectorIconRow/>
        </header>

        <ScreenedCompanies/>

        <section>
          <h2 styleName='profiles-title'>
            Company profiles
          </h2>

          { /* display the profile for each company, in order */
            this.state.orderedCompanyIds.map((cid, idx) => {
              const entry = config.companyProfiles.data[cid]
              const shortName = entry[0]
              const profile = entry[1]
              const pflags = []
              const cflags = []
              const c = config.companySectors.data[cid]
              if (includes(c, 'is_po_p')){ pflags.push(['is_po_p', iconPo, 'Palm oil producer']) }
              if (includes(c, 'is_pp_p')){ pflags.push(['is_pp_p', iconPp, 'Paper/pulp producer']) }
              if (includes(c, 'is_rb_p')){ pflags.push(['is_rb_p', iconRb, 'Rubber producer']) }
              if (includes(c, 'is_tb_p')){ pflags.push(['is_tb_p', iconTb, 'Timber producer']) }
              if (includes(c, 'is_bf_p')){ pflags.push(['is_bf_p', iconBf, 'Cattle producer']) }
              if (includes(c, 'is_sy_p')){ pflags.push(['is_sy_p', iconSy, 'Soy producer']) }

              if (includes(c, 'is_po_c')){ cflags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']) }
              if (includes(c, 'is_pp_c')){ cflags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']) }
              if (includes(c, 'is_rb_c')){ cflags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']) }
              if (includes(c, 'is_tb_c')){ cflags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']) }
              if (includes(c, 'is_bf_c')){ cflags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']) }
              if (includes(c, 'is_sy_c')){ cflags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']) }

              const is_p = pflags.length > 0
              const is_c = cflags.length > 0

              const links = config.companyLinks.data[cid]
              const zsl_spott = links ? links.zsl_spott : ''
              const supply_change = links ? links.supply_change : ''
              const banktrack = links ? links.banktrack : ''
              const rspo = links ? links.rspo : ''
              const forest500 = links ? links.forest500 : ''
              const other_link = links ? links.other_link : ''
              const link_map = [
                [zsl_spott, 'ZSL SPOTT'],
                [supply_change, 'Supply Change'],
                [banktrack, 'BankTrack'],
                [rspo, 'RSPO'],
                [forest500, 'Forest500'],
                [other_link, 'Other']
              ]

              const has_links = (
                zsl_spott ||
                supply_change ||
                banktrack ||
                rspo ||
                forest500 ||
                other_link
              )

              const safeName = shortName.replace('é','e')

              let hasLogo = false
              let companyLogo = null
              try {
                companyLogo = require('../../../static/images/companies/'+cid+'.png')
                hasLogo = true
              }
              catch (e) {
                console.log('')
              }

              //
              return <div key={'ordered_profile_' + idx}>
                <div styleName='company-anchor' id={safeName} />
                <div styleName='family-modal'>
                  <div styleName='family-modal-header-wrap'>
                    <div styleName='family-modal-header'>
                      {shortName}
                    </div>
                    {
                      hasLogo ?
                        <img
                          styleName='company-logo-img'
                          src={companyLogo}
                          alt={shortName}
                        /> :
                        null
                    }
                  </div>
                  <div styleName='family-modal-p'>{profile}</div>
                  <div styleName='modal-icons-wrap'>
                    {
                      is_p ?
                        <div styleName='icons-wrap'>
                          <div styleName='sector-headline-wrap'>
                            <img
                              styleName='sector-icon'
                              src={producersIcon}
                              alt='Agricultural commodity producer/trader'
                            />
                            <div styleName='sector-headline-p'>
                              Agricultural commodity producer/trader
                            </div>
                          </div>
                          { this.renderFlags(pflags) }
                        </div> :
                        null
                    }
                    {
                      is_c ?
                        <div styleName='icons-wrap'>
                          <div styleName='sector-headline-wrap'>
                            <img
                              styleName='sector-icon'
                              src={consumersIcon}
                              alt='Major consumer brands'
                            />
                            <div styleName='sector-headline-c'>
                              Major consumer brand
                            </div>
                          </div>
                          { this.renderFlags(cflags) }
                        </div> :
                        null
                    }
                  </div>
                  { /* if the company has any research links...  */
                    has_links ?
                      <div styleName='links-box'>
                        <div styleName='links-headline'>
                          Source information:
                        </div>
                        { /* ..display links for the company  */
                          link_map.map((e, i) => {
                            // if it has a link:
                            if (e[0].length) {
                              //
                              return <div key={i} styleName='research-link-div'>
                                <Link
                                  to={e[0]}
                                  title={e[1]}
                                  xstrong={true}
                                >
                                  {e[1]}<LinkIcon />
                                </Link>
                              </div>
                            }
                            //
                            return null
                          })
                        }
                      </div> :
                      null
                  }
                </div>
              </div>
            })
          }
        </section>

        <GetStartedInput />
      </ContainerDivs>
    </div>
  }
}
